import f3tch from 'f3tch';

import profile from '../../api/profiles/json.profile.api';

export default (payload) =>
  f3tch('/branches/vehicle_disable_schedules/')
    .profile(profile())
    .body(payload)
    .post();
